/* room-preview.core.js — reine Funktionen, Browser + Node (UMD). Keine DOM-Abhaengigkeit. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  else { root.RoomPreviewCore = api; }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // "100 x 120 cm" | "74 × 105 cm" | "50x50" -> {widthCm, heightCm} | null
  function parseBxh(value) {
    if (typeof value !== 'string') return null;
    var m = value.match(/(\d+(?:[.,]\d+)?)\s*[x×X]\s*(\d+(?:[.,]\d+)?)/);
    if (!m) return null;
    var w = parseFloat(m[1].replace(',', '.'));
    var h = parseFloat(m[2].replace(',', '.'));
    if (!isFinite(w) || !isFinite(h) || w <= 0 || h <= 0) return null;
    return { widthCm: w, heightCm: h };
  }

  // dims(cm) * pxPerCm * displayScale -> {w,h} in Anzeige-Pixeln, gerundet
  function computeArtworkPixelSize(dims, pxPerCm, displayScale) {
    var s = (typeof displayScale === 'number') ? displayScale : 1;
    return {
      w: Math.round(dims.widthCm * pxPerCm * s),
      h: Math.round(dims.heightCm * pxPerCm * s)
    };
  }

  // Werkbreite(px) im Foto -> reale cm, wenn photoWidthPx die wallWidthCm repraesentiert
  function computeWallCm(artworkPx, photoWidthPx, wallWidthCm) {
    if (!wallWidthCm || wallWidthCm <= 0 || !photoWidthPx || photoWidthPx <= 0) return null;
    var pxPerCm = photoWidthPx / wallWidthCm;
    return Math.round(artworkPx / pxPerCm);
  }

  return { parseBxh: parseBxh, computeArtworkPixelSize: computeArtworkPixelSize, computeWallCm: computeWallCm };
});
